module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-header', {
    staticClass: "noPaddingRight",
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.lessonQuestionsTitle'),
      "subTitle": _vm.$t('message.lessonQuestionsSubTitle')
    }
  }), _vm._v(" "), (_vm.changeData) ? _c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeData) ? _c('div', [_c('mu-list', _vm._l((_vm.data.questions), function(question, index) {
    return (_vm.hasQuestions) ? _c('mu-list-item', {
      key: 'question-index-' + index,
      nativeOn: {
        "click": function($event) {
          return _vm.goToQuestion(question.question_id)
        }
      }
    }, [(!question.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n              " + _vm._s(_vm.upperTwoInitials(question.display_name)) + "\n            ")]) : _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": question.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(question.question))
      },
      slot: "title"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticStyle: {
        "color": "rgba(0, 0, 0, .87)"
      },
      domProps: {
        "textContent": _vm._s(question.display_name)
      }
    }), _vm._v("\n                ·\n              "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.formatDate(question.timestamp))
      }
    }), _vm._v(" "), (question.replies !== 0) ? _c('span', [_vm._v("\n                  ·\n                  "), _c('span', {
      domProps: {
        "textContent": _vm._s(question.replies + (question.replies > 1 ? ' replies' : ' reply'))
      }
    })]) : _vm._e()])], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('mu-card-text', [(!_vm.hasQuestions) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$t('message.lessonQuestionsEmpty')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "60",
      "tablet": "70"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "40",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "backgroundColor": "#3d8517",
      "color": "white",
      "label": "Ask a question"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.askQuestion.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2199e88c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/QuestionsPanel/QuestionsPanel.vue
// module id = 3081
// module chunks = 1